import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { api, type AuthStatus, type PublicUser } from "./api.ts";

interface AuthCtx {
  loading: boolean;
  user: PublicUser | null;
  hasOwner: boolean;
  refresh: () => Promise<void>;
  login: (email: string, password: string) => Promise<void>;
  register: (email: string, name: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
}

const Ctx = createContext<AuthCtx>(null!);
export const useAuth = () => useContext(Ctx);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<PublicUser | null>(null);
  const [hasOwner, setHasOwner] = useState(true);

  async function refresh() {
    const st = await api.get<AuthStatus>("/auth/status");
    setUser(st.user);
    setHasOwner(st.hasOwner);
  }

  useEffect(() => {
    refresh().finally(() => setLoading(false));
  }, []);

  async function login(email: string, password: string) {
    const r = await api.post<{ user: PublicUser }>("/auth/login", { email, password });
    setUser(r.user);
    setHasOwner(true);
  }
  async function register(email: string, name: string, password: string) {
    const r = await api.post<{ user: PublicUser }>("/auth/register", { email, name, password });
    setUser(r.user);
    setHasOwner(true);
  }
  async function logout() {
    await api.post("/auth/logout");
    setUser(null);
  }

  return (
    <Ctx.Provider value={{ loading, user, hasOwner, refresh, login, register, logout }}>
      {children}
    </Ctx.Provider>
  );
}
